import React from "react";
import { Image, View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

type Props = {
  variant:
    | "cardMedal"
    | "cardVs"
    | "cardGift"
    | "wallet"
    | "createEventMedal"
    | "buyBeltMedal"
    | "eventCreate"
    | "eventCreateInfo"
    | "proPopup"
    | "profileMedal"
    | "youtubeIcon"
    | "vsImage"
    | "ticket"
    | "cardTicket"
    | "cardVerify"
    | "liveImage"
    | "notificationVs"
    | "notificationBeltMedal"
    | "streamActionIcon";
  src: string;
  item?: any;
};

const SvgImage = ({ variant, src, item }: Props) => {
  const deviceSize = useDeviceSize();

  const isSmallDevice =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;

  const imageStyles = {
    cardMedal: {
      imageActualWidth: 500,
      imageActualHeight: item?.id === 0 ? 500 : 397,
      width: isSmallDevice ? 33 : 48,
      height: isSmallDevice ? 23 : 38,
      scale: isSmallDevice
        ? item?.id === 0
          ? 0.05
          : 0.06
        : item?.id === 0
        ? 0.07
        : 0.09,
      translateX: item?.id === 0 ? 105 : 40,
      translateY: 0,
    },
    createEventMedal: {
      imageActualWidth: item?.id === 0 ? 755 : 950,
      imageActualHeight: item?.id === 0 ? 755 : 720,
      width: item?.width,
      height: item?.height,
      scale: item?.id === 0 ? 0.09 : 0.1,
      translateX: 15,
      translateY: 0,
    },
    profileMedal: {
      imageActualWidth: 500,
      imageActualHeight: 397,
      width: 90,
      height: 68,
      scale: 0.17,
      translateX: 0,
      translateY: 0,
    },
    buyBeltMedal: {
      imageActualWidth: 500,
      imageActualHeight: 397,
      height: 57,
      width: 80,
      scale: 0.14,
      translateX: 35,
      translateY: 0,
    },
    notificationBeltMedal: {
      imageActualWidth: 500,
      imageActualHeight: 397,
      height: 25,
      width: 25,
      scale: 0.05,
      translateX: 0,
      translateY: 0,
    },
    cardVs: {
      imageActualWidth: 500,
      imageActualHeight: 435,
      width: 18,
      height: 40.589,
      scale: 0.04,
      translateX: 0,
      translateY: 0,
    },
    notificationVs: {
      imageActualWidth: 34,
      imageActualHeight: 37,
      width: isSmallDevice ? 18 : 30,
      height: isSmallDevice ? 21 : 30,
      scale: isSmallDevice ? 0.3 : 0.9,
      translateX: isSmallDevice ? 15 : 0,
      translateY: isSmallDevice ? 15 : -2,
    },
    vsImage: {
      imageActualWidth: 221,
      imageActualHeight: 220,
      width: 50,
      height: 100,
      scale: 0.5,
      translateX: -70,
      translateY: 0,
    },
    cardGift: {
      imageActualWidth: 500,
      imageActualHeight: 600,
      width: isSmallDevice ? 18 : 26,
      height: isSmallDevice ? 24 : 32,
      scale: isSmallDevice ? 0.04 : 0.05,
      translateX: isSmallDevice ? 30 : 100,
      translateY: isSmallDevice ? -40 : 30,
    },
    wallet: {
      imageActualWidth: 700,
      imageActualHeight: 700,
      width: isSmallDevice ? 31 : 40,
      height: isSmallDevice ? 31 : 40,
      scale: 0.06,
      translateX: isSmallDevice ? 30 : 100,
      translateY: isSmallDevice ? -40 : 30,
    },
    eventCreate: {
      imageActualWidth: 283,
      imageActualHeight: 283,
      height: isSmallDevice ? 150 : 200,
      width: isSmallDevice ? 150 : 200,
      scale: isSmallDevice ? 0.5 : 0.7,
      translateX: 0,
      translateY: isSmallDevice ? 15 : 0,
      margin: 10,
    },
    eventCreateInfo: {
      imageActualWidth: 283,
      imageActualHeight: 283,
      height: 100,
      width: 100,
      scale: 0.35,
      translateX: 0,
      translateY: 0,
      borderRadius: 8,
    },
    proPopup: {
      imageActualWidth: item?.width,
      imageActualHeight: item?.height,
      width: 45,
      height: 45,
      scale: 0.8,
      translateX: 0,
      translateY: 0,
    },
    youtubeIcon: {
      imageActualWidth: 64,
      imageActualHeight: 66,
      width: 56,
      height: 56,
      scale: 0.84,
      translateX: 0,
      translateY: 0,
    },
    ticket: {
      imageActualWidth: 53,
      imageActualHeight: 55,
      height: 113,
      width: 116,
      scale: 2,
      translateX: 0,
      translateY: 0,
    },
    cardTicket: {
      imageActualWidth: 53,
      imageActualHeight: 55,
      height: 26,
      width: 26,
      scale: 0.5,
      translateX: 0,
      translateY: 0,
    },
    cardVerify: {
      imageActualWidth: 19,
      imageActualHeight: 19,
      height: isSmallDevice ? 10 : 15,
      width: isSmallDevice ? 10 : 15,
      scale: isSmallDevice ? 0.5 : 0.8,
      translateX: 0,
      translateY: 0,
    },
    liveImage: {
      imageActualWidth: 123,
      imageActualHeight: 122,
      width: 122,
      height: 122,
      scale: 1,
      translateX: 0,
      translateY: 0,
    },
    streamActionIcon: {
      imageActualWidth: 24,
      imageActualHeight: 24,
      width: 24,
      height: 24,
      scale: 1,
      translateX: 0,
      translateY: 0,
    },
  };

  if (!imageStyles[variant]) {
    return null;
  }

  return (
    <View
      style={{
        height: imageStyles[variant].height,
        width: imageStyles[variant].width,
        // overflow: "hidden",
      }}
    >
      <Image
        source={{ uri: src }}
        style={{
          transform: [
            { scaleX: imageStyles[variant].scale },
            { scaleY: imageStyles[variant].scale },
            { translateX: imageStyles[variant].translateX },
            { translateY: imageStyles[variant].translateY },
          ],
          transformOrigin: "top left",
          height: imageStyles[variant].imageActualHeight,
          width: imageStyles[variant].imageActualWidth,
        }}
      />
    </View>
  );
};

export default SvgImage;
